<template>
    <div>
        <Drawer :title="'[' + user_info.name + ']，欢迎回来！选择系统直接进入~'" :closable="true" v-model="show" placement="top"
            height="200" :mask-closable='false' class-name="drawer_class" @on-visible-change="show_change">
            <div class="sys_btn_main">
                <div v-for="(item, i) in sys_list" :key="i" class="sys_btn_box" @click="click_sys(item, i)">
                    <div class="sys_btn_div" v-if="!item.sys_auth">
                        <Icon type="md-lock" class="sys_lock_icon" />
                    </div>
                    <div style="background:#e2e2e2 " class="sys_btn" v-if="!item.sys_auth">
                        <div class="sys_icon_innner">
                            <img :src="item.img" alt="" class="sys_icon">
                        </div>
                        <div class="sys_name_inner">
                            {{ item.name }}
                        </div>
                    </div>
                    <div :style="'background:' + item.color" class="sys_btn" v-else>
                        <div class="sys_icon_innner">
                            <img :src="item.img" alt="" class="sys_icon">
                        </div>
                        <div class="sys_name_inner">
                            {{ item.name }}
                        </div>
                    </div>
                </div>
            </div>
            <transition name="move-right" v-if="show_group">
                <div class="group_img_div">
                    <div class="group_img_close">
                        <span @click="close_wx_group_qr">
                            <Icon type="ios-close-circle" size="26" color="#ccc" />
                        </span>
                    </div>
                    <img class="group_img" :src="group_url" alt="">
                </div>
            </transition>
        </Drawer>



    </div>
</template>

<script>
import { http, open_new_page } from "@/utils/http.js";

export default {
    name: "cut_sys",
    data() {
        return {
            sys_list: [],
            show: false,
            user_info: {
                name: '',
                avatar: ""
            },
            group_url: '',
            show_group: true
        }
    },
    mounted() {
    },
    methods: {


        close_wx_group_qr(){
            this.$Message.info('关不掉哟，嘻嘻')
        },

        show_change(e) {
            if (e) {
                this.$emit('change', 'open')
            }else{
                this.$emit('change', 'close')
            }
        },

        get_img_group() {
            var that = this
            var obj = {

            }
            http("post", process.env.VUE_APP_HOST + "/login_dx/im_group", obj, true, 'staff').then(
                (res) => {
                    console.log(res)
                    if (res.code == 0) {
                        that.show_group = true
                        that.group_url = res.data.url

                    } else {


                    }


                }
            ).catch((res) => {

                console.log(res, '请求出错')
            })
        },

        open() {
            this.get_sys_list()
            this.get_img_group()
        },

        //点击切换系统
        click_sys(item, i) {
            if (item.sys_auth) {
                var url = item.url
                this.$emit('change','open')
                open_new_page(url, '_blank')
            } else {
                this.$Message.error('没有这个系统登录权限')
            }

        },


        //获取用户列表
        get_sys_list() {
            console.log('获取系统列表')
            var that = this
            var obj = {}
            http("post", process.env.VUE_APP_HOST + "/login_dx/web_sys_list", obj, true, 'staff').then(
                (res) => {
                    console.log(res)
                    if (res.code == 0) {
                        that.sys_list = res.data.sys_list
                        that.user_info = res.data.user_info
                        // that.show = true
                        // that.$emit('change', 'open')
                        console.log('跳转用户中心')
                        that.$router.push({'path':'/user/index'})

                    } else {
                        that.$Message.info('请先登录哟~')

                    }


                }
            ).catch((res) => {

                console.log(res, '请求出错')
            })
        },
    }
}
</script>

<style  scoped>
.group_img_close {
    position: relative;
    top: 35px;
    right: 10px;
    text-align: right;
    cursor: pointer;
}

.group_img {
    border-radius: 10px;
    box-shadow: 0 0 3px #ccc;
    width: 260px;
    height: 400px;
}

.group_img_div {
    text-align: center;
    position: fixed;
    right: 15px;
    top: 190px;
}

.sys_btn_div {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.sys_lock_icon {
    position: absolute;
    font-size: 40px;
    top: 20px;
    color: #0466dd;
    opacity: .7;
}

.sys_btn_box {
    margin: 10px 10px 10px 5px;
    cursor: pointer;
    position: relative;

}

.sys_btn_main {
    display: flex;
    flex-wrap: wrap;

}

.sys_name_inner {
    display: flex;
    justify-content: center;
    margin-top: 10px;
}

.sys_icon_innner {
    display: flex;
    justify-content: center;
}

.sys_icon {
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
}

.sys_btn {
    padding: 10px 10px 10px 10px;
    width: 110px;
    color: #fff;
    border-radius: 10px;
}
</style>